module.exports = __webpack_public_path__ + "img/icon-flag.6a84d63b.svg";